import { useContext, useEffect, useRef, useState } from "react";
import "./ContestPage.css";
// import back from "../assests/back.svg";
import back from "../assests/popup/backButton.svg";

import ContestTerms from "../Components/ContestDescripion/ContestTerms";
import ImageGallery from "../Components/ImgContestPage/ImageGallery";
import Context from "../context/Context";
import { useUserAuth } from "../context/UserAuthContext";
import Contest from "./Contest";
import HowToParticipate from "../Components/HowToParticipate/HowToParticipate";
import caution from "../assests/caution.svg";
import goviralLogo23 from "../assests/goviralLogo23.svg";
import UploadSuccess from "../Components/UploadSuccess/UploadSucess";
import VoucherValidation from "../Components/VoucherValidation/VoucherValidation";
import Sponsors from "../Components/Sponsors/Sponsors";
import { useLocation, useNavigate, useParams } from "react-router";
import Judges from "./Judges";
import Bluearrow from "../assests/blueArrow.png";
import Header from "../Components/Header/Header";
import * as _ from "lodash";
import MyEntriesInContest from "../Components/MyEntriesInContest/MyEntriesInContest";
import Promoters from "./Promoters";
import Sponsers from "./Sponsers";
import PeopleInCarousel from "../Components/DynamicCarousel/JudgesInCarousel";
import JudgesInCarousel from "../Components/DynamicCarousel/JudgesInCarousel";
import PromotorsInCarousel from "../Components/DynamicCarousel/PromotorsInCarousel";
import SponsersInCarosel from "../Components/DynamicCarousel/SponsersInCarosel";
import PrizeWithText from "../Components/DynamicCarousel/PrizeWithText";
import PrizeWithImage from "../Components/DynamicCarousel/PrizeWithImage";
import HowToParticiapteInCarousel from "../Components/DynamicCarousel/HowToParticiapteInCarousel";
import HowToParticipatePopup from "../Components/SingleVideoPlayer/SingleVideoPlayer";
import MultipleEntryPopup from "../Components/MultipleEntryPopup/MultipleEntryPopup";
import Lottie from "react-lottie-player";
import loadingAnimation from "../assests/loading.json";
import NavigationHeader from "../Components/NavigationHeader/NavigationHeader";
import axios from "axios";
import FloatingWidgets from "../Components/FloatingWidgets/FloatingWidgets";
import JudgesPopup from "../Components/JudgesPopup/JudgesPopup";
import SponsorPopup from "../Components/SponsorPopup/SponsorPopup";
import PromoterPopup from "../Components/PromoterPopup/PromoterPopup";
import Organizer from "./Organizer";
import OrganizerInCarosel from "../Components/DynamicCarousel/OrganizerInCarosel";
import OrganizerPopup from "../Components/OrganizerPopup/OrganizerPopup";
import { createSearchParams } from "react-router-dom";
import SpecialGuests from "./SpecialGuests";
import GuestPopup from "../Components/GuestPopup/GuestPopup";
import DemoPerformance from "../Components/DemoPerformance/DemoPerformance";
import Ads from "../Components/Ads/Ads";
import Coupons from "../Components/Coupons/Coupons";
import ServiceForm from "../Components/ServiceForm/ServiceForm";
import SupportedBy from "./SupportedBy";
import EmailVerification from "../Components/EmailVerification/EmailVerification";
import InstaGramParticipatePopup from "../Components/InstaGramParticipatePopup/InstaGramParticipatePopup";
import EligiblePopup from "../Components/EligiblePopup/EligiblePopup";
import hoeLogo from "../assests/hoeLogo.png";
import { authentication } from "../store/firebase-config";

const CarouselDot = ({ active, onClick, id }) => {
  const dotClass = `carousel-dot ${active ? "carousel-dot-active" : ""}`;
  return <div className={dotClass} onClick={onClick} id={id} />;
};
function ContestPage() {
  const {
    uploadSuccess,
    setUploadSucccess,
    loadHomePageDetails,
    organizerId,
    uploadSuccessFile,
    organizerName,
    contestImageGalleryContents,
    setFilterState,
    preview,
    setValidationComplete,
    details,
    loadContestRules,
    verifyUser,
    userIdToken,
    setPinData,
    setGeneratedPosterUrl,
    coupons,
    setCoupons,
    ads,
    setAds,
    contestScrollPositionRef,
    buildType,
    isDomainAllowed,
  } = useContext(Context);
  const {
    emailVerified,
    emailPopup,
    setEmailPopup,
    fetchUserData,
    currentUser,
    searchParams,
  } = useUserAuth();

  const [showDetails, setShowDetails] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showFAQ, setShowFAQ] = useState(false);
  // const [hidden, setSh] = useState(false)
  const [showVoucher, setshowVoucher] = useState(false);
  const contestId = window.location.pathname
    .split("/")[3]
    ?.replace(/\.html$/, "");
  const cardRefs = useRef([]);
  const campaignId = window.location.pathname
    .split("/")[2]
    ?.replace(/\.html$/, "");

  const location = useLocation();
  const [participate, setParticipate] = useState(false);
  const [sponsors, showSponsors] = useState(false);
  const [sponserDetails, setSponserDetails] = useState({});
  const [multipleEntryPopup, setMultipleEntryPopup] = useState(false);
  const [eligiblePopup, setEligiblePopup] = useState(false);
  const [cutOffPopup, setCutOffPopup] = useState(false);
  const [howToParticipatePopup, setHowToParticipatePopup] = useState(false);
  const [contestParticipationTimeOut, setContestParticipationTimeOut] =
    useState();
  const [judgesPopup, setJudgesPopup] = useState(false);
  const [judgeDetails, setJudgeDetails] = useState({});
  const [promoterPopup, setPromoterPopup] = useState(false);
  const [promoterDetails, setPromoterDetails] = useState({});
  const [sponsorPopup, setSponsorPopup] = useState(false);
  const [sponsorDetails, setSponsorDetails] = useState({});
  const [organizerPopup, setOrganizerPopup] = useState(false);
  const [organizerDetails, setOrganizerDetails] = useState({});
  const [guestPopup, setGuestPopup] = useState(false);
  const [guestDetails, setGuestDetails] = useState({});
  const [service, setService] = useState();
  const [serviceForm, setServiceForm] = useState(false);
  const [detailsPopup, setDetailsPopup] = useState(false);
  const [emailError, setEmailError] = useState("");

  useEffect(() => {
    loadHomePageDetails(organizerName, campaignId);
    // eslint-disable-next-line
  }, [organizerName]);
  const voucher = searchParams?.get("vc");
  const navigate = useNavigate();
  useEffect(() => {
    if (!_.isEmpty(details))
      window.scrollTo({
        top: contestScrollPositionRef.current,
        behavior: "smooth",
      });
  }, [details]);

  useEffect(() => {
    const checkDomain = async () => {
      if (!_.isEmpty(details?.allowedDomains)) {
        const domainAllowed = await isDomainAllowed(
          currentUser?.email,
          details?.allowedDomains
        );
        if (!domainAllowed) {
          setEmailError(
            `This email address is not authorized to access the contest. Kindly get in touch with your Company Admin for access.`
          );
          return;
        }
      }
    };
    if (!_.isEmpty(details)) {
      if (details?.closedCampaign) {
        if (currentUser) {
          checkDomain();
        } else {
          handleSignup(false);
        }
      }
    }
  }, [details]);

  const token = userIdToken || currentUser?.accessToken;
  var contestDetails =
    details &&
    details.contests &&
    details.contests.filter((el) => {
      return el.contestUniqueText === contestId;
    });
  let orgId = contestDetails && contestDetails[0]?.orgId;
  let cntstid = contestDetails && contestDetails[0]?.contestId;
  let cmpId = contestDetails && contestDetails[0]?.campaignId;
  const isPrivate = contestDetails && contestDetails[0]?.isPrivate;

  useEffect(() => {
    if (orgId || cmpId) {
      loadAdsDetails(orgId, cmpId);
    }
  }, [orgId, cmpId]);
  // let participantsCounter = contestDetails && contestDetails[0].participantsCounter
  const contestName = contestDetails && contestDetails[0]?.contestName;
  let organiserId = contestDetails && contestDetails[0]?.orgId;
  const campaignType = details?.campaignType;
  const coSponserDetails = contestDetails && contestDetails[0]?.coSponser;
  const buttonColor = contestDetails && contestDetails[0]?.buttonColor;
  const contestRules = {
    tandc: contestDetails && contestDetails[0]?.contestRules,
  };
  let judgeIdArray = contestDetails && contestDetails[0]?.judges;
  let contestJudges = details?.judges?.filter((el) =>
    judgeIdArray?.some((el2) => el2 == el?._id)
  );

  const rulesAndRegulations = {
    tandc: contestDetails && contestDetails[0]?.rulesAndRegulations,
  };

  const hideFaq = details?.hideFaq;
  const hideRulesAndReg = details?.hideRulesAndReg;
  const hideTandC = details?.hideTandC;

  const faq = {
    tandc: details?.faq,
  };
  const [contestClosed, setContestClosed] = useState(false);
  useEffect(() => {
    verifyUser();
    // eslint-disable-next-line
  }, []);

  const organizerName_fromURL = window.location.href.split("/")[3];
  const campaignName_fromURL = window.location.href.split("/")[4];
  const handleNavigate = () => {
    navigate(`/${organizerName_fromURL}/${campaignName_fromURL}`);
    setFilterState(
      _.isEmpty(details?.filterChips) ? "ALL" : contestDetails?.contestType
    );
  };
  const profileHelpNavigate = () => {
    if (preview) {
      navigate({
        pathname: `/profile/help`,
        search: "?preview=true",
      });
    } else {
      navigate({
        pathname: `/profile/help`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    }
  };
  const handleClick = () => {
    setHowToParticipatePopup(true);
  };
  const displayOrder = [
    {
      name: "howToParticipate",
    },
    { name: "prizeDetails" },
    {
      name: "judges",
    },
    {
      name: "promoters",
    },
    {
      name: "sponsors",
    },
    {
      name: "organizer",
    },
  ];
  const components = {
    judges: (
      <JudgesInCarousel
        judges={contestJudges}
        setJudgesPopup={setJudgesPopup}
        setJudgeDetails={setJudgeDetails}
        scrollRef={(element) => {
          cardRefs.current["judges"] = element;
        }}
      />
    ),
    promoters: (
      <PromotorsInCarousel
        promoters={details?.promoters}
        setPromoterPopup={setPromoterPopup}
        setPromoterDetails={setPromoterDetails}
        scrollRef={(element) => {
          cardRefs.current["promoters"] = element;
        }}
      />
    ),
    howToParticipate: (
      <HowToParticiapteInCarousel
        howToParticipate={details?.howToParticipate}
        handleClick={handleClick}
        scrollRef={(element) => {
          cardRefs.current["howToParticipate"] = element;
        }}
      />
    ),
    sponsors: (
      <SponsersInCarosel
        heading="Contest sponsors"
        sponsers={details?.sponsors}
        hexCode={contestDetails && contestDetails[0]?.buttonColor}
        setSponsorPopup={setSponsorPopup}
        setSponsorDetails={setSponsorDetails}
        scrollRef={(element) => {
          cardRefs.current["sponsors"] = element;
        }}
      />
    ),
    organizer: (
      <OrganizerInCarosel
        heading="Contest Organizer"
        organizer={details?.organizer}
        hexCode={contestDetails && contestDetails[0]?.buttonColor}
        setOrganizerPopup={setOrganizerPopup}
        setOrganizerDetails={setOrganizerDetails}
        scrollRef={(element) => {
          cardRefs.current["organizer"] = element;
        }}
      />
    ),
    prizeDetails:
      contestDetails && contestDetails[0]?.prizeDetails?.type === "text" ? (
        <PrizeWithText
          heading="Online Contest prizes"
          prizeDetails={contestDetails && contestDetails[0].prizeDetails}
          hexCode={contestDetails && contestDetails[0]?.buttonColor}
          scrollRef={(element) => {
            cardRefs.current["prizeDetails"] = element;
          }}
        />
      ) : contestDetails &&
        contestDetails[0]?.prizeDetails?.type === "image" ? (
        <PrizeWithImage
          heading="Online Contest prizes"
          prizeDetails={contestDetails && contestDetails[0].prizeDetails}
          hexCode={contestDetails && contestDetails[0]?.buttonColor}
          scrollRef={(element) => {
            cardRefs.current["prizeDetails"] = element;
          }}
        />
      ) : null,
  };

  const renderComponentsInOrder = (displayOrder) => {
    const orderToRender = details?.sections || displayOrder;
    return orderToRender
      .filter((componentName) => {
        // check if component name is defined and data exists in details JSON
        return componentName?.name && details && details[componentName?.name];
      })
      ?.map((componentName) => {
        // return the component if it exists in the components object
        return components[componentName?.name];
      });
  };
  const orderedComponents = renderComponentsInOrder(displayOrder);
  let isJudgE = "theBlurBg";

  //function to change slider active dot
  const [activeIndex, setActiveIndex] = useState(0);

  const sliderRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (event) => {
    setIsDragging(true);
    setStartX(event.clientX - sliderRef.current.offsetLeft);
    setScrollLeft(sliderRef.current.scrollLeft);
  };

  const handleMouseMove = (event) => {
    if (!isDragging) return;
    const x = event.clientX - sliderRef.current.offsetLeft;
    const scroll = x - startX;
    sliderRef.current.scrollLeft = scrollLeft - scroll;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };
  const handleSlideChange = (index, componentName) => {
    setActiveIndex(index);
    if (cardRefs.current[componentName]) {
      cardRefs.current[componentName].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  };
  const handleNext = () => {
    let currentIndex = activeIndex;
    const orderToRender = details?.sections || displayOrder;

    let nextIndex;
    if (currentIndex + 1 == orderToRender?.length) {
      nextIndex = currentIndex;
    } else {
      nextIndex = currentIndex + 1;
    }
    setActiveIndex(nextIndex);
    let nextComponent =
      orderToRender[nextIndex] && orderToRender[nextIndex].name;
    if (cardRefs.current[nextComponent]) {
      cardRefs.current[nextComponent].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  };

  const handlePrevious = () => {
    let currentIndex = activeIndex;
    const orderToRender = details?.sections || displayOrder;

    let prevIndex;
    if (currentIndex == 0) {
      prevIndex = currentIndex;
    } else {
      prevIndex = currentIndex - 1;
    }
    setActiveIndex(prevIndex);
    let prevComponent =
      orderToRender[prevIndex] && orderToRender[prevIndex].name;
    if (cardRefs.current[prevComponent]) {
      cardRefs.current[prevComponent].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  };
  useEffect(() => {
    const slider = sliderRef.current;
    const handleScroll = () => {
      const sliderWidth = sliderRef.current.offsetWidth;
      const sliderLeft = sliderRef.current.getBoundingClientRect().left;
      const activeSlide = Array.from(sliderRef.current.children).find(
        (slide) => {
          const slideLeft = slide.getBoundingClientRect().left;
          return slideLeft >= sliderLeft;
        }
      );
      setActiveIndex(
        activeSlide ? Array.from(slider.children).indexOf(activeSlide) : 0
      );
    };
    slider?.addEventListener("scroll", handleScroll);
    return () => slider?.removeEventListener("scroll", handleScroll);
  }, []);
  const orderToRender = details?.sections || displayOrder;

  const dots = orderToRender
    .filter((componentName) => {
      // check if component name is defined and data exists in details JSON
      return componentName?.name && details && details[componentName?.name];
    })
    .map((componentName, index) => (
      <CarouselDot
        key={index}
        active={index === activeIndex}
        id={`dot-${index}`}
        onClick={() => handleSlideChange(index, componentName?.name)}
      />
    ));

  const [isFixed, setIsFixed] = useState(false);
  const [isPlaying, setIsplaying] = useState(false);
  const [participateLoading, setParticipateLoading] = useState(false);
  const audioElem = useRef();
  useEffect(() => {
    if (voucher) {
      handleParticipate();
    }
  }, []);
  useEffect(() => {
    if (location?.state?.participate && !_.isEmpty(details)) {
      handleParticipate();
    }
    return () => {
      window.history.replaceState({}, document.title);
    };
  }, [details]); //navigation to particiapte when comes from sigup page

  useEffect(() => {
    if (
      emailVerified == false &&
      details?.likeType == "NORMAL" &&
      details?.closedCampaign
    ) {
      setEmailPopup(true);
      return;
    }
  }, [emailVerified]);

  const handleParticipate = async () => {
    if (
      emailVerified == false &&
      details?.likeType == "NORMAL" &&
      details?.closedCampaign
    ) {
      // const userData = await fetchUserData();
      // if (userData?.emailVerified == false) {
      //   setEmailPopup(true);
      //   return;
      // }
      setEmailPopup(true);
      return;
    }
    setGeneratedPosterUrl("");
    setValidationComplete(false);
    let selectedContestDetails = contestDetails && contestDetails[0];
    if (campaignType == "DA_PAID" || campaignType == "MOV") {
      setIsplaying(false);
      audioElem.current.pause();
    }
    if (isPrivate) {
      setshowVoucher(true); // to enter voucher code
    } else if (selectedContestDetails?.posterContest) {
      navigate(`/poster/${selectedContestDetails.posterContest}`);
    } else if (selectedContestDetails?.faceSwapContest) {
      navigate(`/faceswap/${selectedContestDetails.faceSwapContest}`);
    } else {
      verifyVoucher(); //validation chceck for public campaign
    }
  };
  const verifyVoucher = async () => {
    try {
      setParticipateLoading(true);
      let url = "";
      let selectedContestDetails = contestDetails && contestDetails[0];
      if (selectedContestDetails?.contestType == "QUIZ_CHAINED") {
        url = `${process.env.REACT_APP_VALIDATE_UPLOAD_QUIZ}/${orgId}/${cmpId}/${cntstid}`;
      } else {
        url = `${process.env.REACT_APP_VALIDATE_UPLOAD}/${orgId}/${cmpId}/${cntstid}`;
      }
      let config = {
        method: "post",
        url: url,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const response = await axios(config);

      if (response.data.data.multipleEntriesFound) {
        setParticipateLoading(false);
        setMultipleEntryPopup(true);
        setshowVoucher(false);
        setParticipate(false);
      } else if (response.data.data.validationCompleted) {
        setValidationComplete(true);
        setParticipateLoading(false);
        navigate({
          pathname: `/${organizerName}/${campaignId}/${contestId}/participate`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        });
      } else if (!response.data.data.eligible) {
        setParticipateLoading(false);
        setEligiblePopup(true);
        setshowVoucher(false);
        setParticipate(false);
        return;
      } else if (!response.data.data.cutOffAdded) {
        setParticipateLoading(false);
        setCutOffPopup(true);
        setshowVoucher(false);
        setParticipate(false);
        return;
      } else {
        if (response.data.data.isVoucherValid && response.status === 201) {
          setPinData(response);
          setParticipateLoading(false);

          navigate({
            pathname: `/${organizerName}/${campaignId}/${contestId}/participate`,
            search: `${searchParams ? createSearchParams(searchParams) : ""}`,
          });
        } else if (!response.data.data.isVoucherValid) {
          setParticipateLoading(false);

          navigate({
            pathname: `/${organizerName}/${campaignId}/${contestId}/participate/error`,
            search: `${searchParams ? createSearchParams(searchParams) : ""}`,
          });
        }
      }
    } catch (error) {
      setParticipateLoading(false);

      navigate({
        pathname: `/${organizerName}/${campaignId}/${contestId}/participate`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    }
  };

  const handleSignup = (participate = false) => {
    navigate(
      {
        pathname: `/${organizerName}/${campaignId}/signup`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      },
      {
        state: {
          participate: participate,
          previousLocation: location?.pathname,
        },
      }
    );
  };

  useEffect(() => {
    const handleScroll = () => {
      const contentOffset =
        document.getElementById("content").getBoundingClientRect().top - 50;
      setIsFixed(contentOffset < 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  var cardColour = details?.bgColor || "#F6E7D8";

  const rgbaColor = `rgba(${parseInt(cardColour?.slice(1, 3), 16)}, ${parseInt(
    cardColour?.slice(3, 5),
    16
  )}, ${parseInt(cardColour?.slice(5, 7), 16)}, 0.55)`;
  const navigateButton = {
    backgroundColor: rgbaColor,
    filter: `filter: drop-shadow(-3px 2px 2px rgba(0, 0, 0, 0.48));`,
  };
  const loadAdsDetails = async (orgId, campaignId) => {
    try {
      const data = await axios.get(
        `https://storage.googleapis.com/goviral-share/${orgId}/${campaignId}/ads.json`
      );
      setAds(data.data?.ads?.ads);
      setCoupons(data.data?.discountCoupons);
    } catch (error) {
      console.log(error.message);
      //navigate("/error")
    }
  };
  let infId = searchParams.get("presentedBy") || searchParams.get("p");

  const handleClickCounterCampaign = async (
    brandId,
    id,
    adsName,
    brandName,
    type,
    catType
  ) => {
    let config = {
      method: "post",
      url: `${process.env.REACT_APP_HIT_COUNTER_CAMPAIGN}/${cmpId}/${orgId}/${brandId}/${id}?type=${type}&catType=${catType}`,
      data: {
        name: adsName,
        brandName: brandName,
        token: token ? token : "null",
        infId: parseInt(infId),
      },
    };

    const response1 = await axios(config);
  };

  if (showVoucher || sponsors || participate) {
    return (
      <div className="relative widthController">
        {/* How to Participate popup */}
        {participate && (
          <HowToParticipate
            setParticipate={setParticipate}
            contestRules={contestRules}
            contestDetails={contestDetails && contestDetails[0]}
            setshowVoucher={setshowVoucher}
            setMultipleEntryPopup={setMultipleEntryPopup}
            contestClosed={contestClosed}
          />
        )}
        {/* Sponsors popup */}
        {sponsors && (
          <Sponsors
            showSponsors={showSponsors}
            sponserDetails={sponserDetails}
          />
        )}
        {showVoucher && (
          <VoucherValidation
            setshowVoucher={setshowVoucher}
            singleFileDetails={contestDetails && contestDetails[0]}
            setMultipleEntryPopup={setMultipleEntryPopup}
          />
        )}
      </div>
    );
  } else {
    return (
      <div className="widthController z-[1] relative">
        {emailPopup && (
          <EmailVerification
            setPopup={setEmailPopup}
            closedCampaign={details?.closedCampaign}
          />
        )}
        {_.isEmpty(details) ? (
          <div className="w-[100%] h-[100vh] flex items-center justify-center">
            <Lottie
              loop
              animationData={loadingAnimation}
              play
              style={{ width: 173, height: 173 }}
            />
          </div>
        ) : (
          <div className="relative mx-auto flex flex-col ">
            <FloatingWidgets
              page="campaign"
              prize={details?.priceDescription}
              endTime={contestDetails && contestDetails[0]?.endDate}
              color={contestDetails && contestDetails[0]?.buttonColor}
            />
            <NavigationHeader
              isFixed={isFixed}
              type="contest"
              handleParticipate={handleParticipate}
              participateLoading={participateLoading}
              contestClosed={contestClosed}
              contestDetails={contestDetails && contestDetails[0]}
              handleSignup={handleSignup}
              contestParticipationTimeOut={contestParticipationTimeOut}
            />
            <Header
              details={details}
              type="contest"
              coverImage={contestDetails && contestDetails[0]?.contestPoster}
              headingStyle={
                contestDetails && contestDetails[0]?.campaignNameStyle
              }
              heading={contestDetails && contestDetails[0]?.contestName}
            />

            {/* <div className="md:sticky fixed top-4 left-4">
            <div
              // className="h-[50px] w-[50px] bg-[#252525] rounded-full  flex items-center justify-center cursor-pointer"

              onClick={handleNavigate}
            >
               
            </div>
          </div> */}
            <div className="">
              <div
                className=" w-[100%] mt-[350px] theBlurBgContestPage rounded-t-[24px]"
                id="content"
              >
                <Contest
                  setParticipate={setParticipate}
                  showSponsors={showSponsors}
                  contestDetails={contestDetails && contestDetails[0]}
                  setSponserDetails={setSponserDetails}
                  setContestClosed={setContestClosed}
                  contestClosed={contestClosed}
                  handleParticipate={handleParticipate}
                  isPlaying={isPlaying}
                  setIsplaying={setIsplaying}
                  audioElem={audioElem}
                  participateLoading={participateLoading}
                  handleSignup={handleSignup}
                  contestParticipationTimeOut={contestParticipationTimeOut}
                  setContestParticipationTimeOut={
                    setContestParticipationTimeOut
                  }
                />
                {!details?.hideSection && (
                  <div className="relative">
                    <div
                      className="flex box w-[100%] gap-[16px] overflow-x-auto px-[20px] no-scrollbar mt-[20px] z-1 relative mb-[16px] cursor-move"
                      ref={sliderRef}
                      onMouseDown={handleMouseDown}
                      onMouseMove={handleMouseMove}
                      onMouseUp={handleMouseUp}
                      onMouseLeave={handleMouseUp}
                    >
                      {orderedComponents}
                    </div>
                    <div className="w-[100%] flex items-center justify-center gap-[6px] relative z-1">
                      {dots}
                    </div>
                    <button
                      onClick={handlePrevious}
                      style={navigateButton}
                      className="absolute top-[38%] z-10 left-[5px] cursor-pointer hidden md:flex w-[30px] h-[30px] rounded-full  items-center justify-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="7"
                        height="11"
                        viewBox="0 0 7 11"
                        fill="none"
                      >
                        <path
                          d="M6.71106 0.244134C6.33051 -0.081378 5.71346 -0.081378 5.33292 0.244134L0.570187 4.32225C-0.190306 4.97336 -0.190013 6.0285 0.570773 6.67936L5.33643 10.7559C5.71697 11.0814 6.33402 11.0814 6.71457 10.7559C7.09514 10.4303 7.09514 9.90253 6.71457 9.57699L2.63572 6.08793C2.25508 5.76242 2.25508 5.2346 2.63572 4.90909L6.71106 1.42298C7.09162 1.09747 7.09162 0.56973 6.71106 0.244134Z"
                          fill="#606060"
                        />
                      </svg>
                    </button>
                    <buttton
                      onClick={handleNext}
                      style={navigateButton}
                      className="absolute top-[38%] z-10 right-[5px] cursor-pointer hidden md:flex w-[30px] h-[30px] rounded-full  items-center justify-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="7"
                        height="11"
                        viewBox="0 0 7 11"
                        fill="none"
                      >
                        <path
                          d="M0.288944 10.7559C0.669493 11.0814 1.28654 11.0814 1.66708 10.7559L6.42981 6.67775C7.19031 6.02664 7.19001 4.9715 6.42923 4.32064L1.66357 0.244147C1.28303 -0.0813822 0.665985 -0.0813822 0.285426 0.244147C-0.0951421 0.569684 -0.0951421 1.09747 0.285426 1.42301L4.36428 4.91207C4.74492 5.23758 4.74492 5.7654 4.36428 6.09091L0.288944 9.57702C-0.0916245 9.90253 -0.0916245 10.4303 0.288944 10.7559Z"
                          fill="#606060"
                        />
                      </svg>
                    </buttton>
                  </div>
                )}

                {!_.isEmpty(
                  contestDetails && contestDetails[0]?.demoPerformance
                ) && (
                  <div className="px-[20px] relative z-[1]">
                    <DemoPerformance
                      data={
                        contestDetails && contestDetails[0]?.demoPerformance
                      }
                    />
                    <div className="seperator" />
                  </div>
                )}
                {multipleEntryPopup && (
                  <MultipleEntryPopup
                    buttonColor={buttonColor}
                    setMultipleEntryPopup={setMultipleEntryPopup}
                    contestDetails={contestDetails && contestDetails[0]}
                  />
                )}
                {emailError && (
                  <EligiblePopup
                    buttonColor={buttonColor}
                    // setPopup={setEmailError}
                    contestDetails={contestDetails && contestDetails[0]}
                    // heading="Sorry! You are not eligible to participate in this contest."
                    description={emailError}
                    button2="Use Different Email"
                    button2Function={() => {
                      authentication.signOut();
                      window.location.reload();
                    }}
                  />
                )}
                {eligiblePopup && (
                  <EligiblePopup
                    buttonColor={buttonColor}
                    setPopup={setEligiblePopup}
                    contestDetails={contestDetails && contestDetails[0]}
                    heading="Sorry! You are not eligible to participate in this contest."
                    description="Your score is below the cutoff mark."
                  />
                )}
                {cutOffPopup && (
                  <EligiblePopup
                    buttonColor={buttonColor}
                    setPopup={setCutOffPopup}
                    contestDetails={contestDetails && contestDetails[0]}
                    heading="Sorry! The cutoff mark for this contest is not added."
                    description="Please try again later"
                  />
                )}

                {!participate && (
                  <MyEntriesInContest
                    campaignId={cmpId && cmpId}
                    contestId={cntstid && cntstid}
                    userToken={token}
                    organiserId={organiserId && organiserId}
                    campaignType={campaignType}
                    buttonColor={buttonColor}
                    contestDetails={contestDetails && contestDetails[0]}
                  />
                )}

                {!participate && (
                  <ImageGallery
                    campaignId={cmpId && cmpId}
                    contestId={cntstid && cntstid}
                    userToken={token}
                    organiserId={organiserId && organiserId}
                    campaignType={campaignType}
                    buttonColor={buttonColor}
                    contestDetails={contestDetails && contestDetails[0]}
                  />
                )}
                <div className="px-[20px] mt-[30px] relative z-1">
                  <div className="seperator" />
                </div>
                {!_.isEmpty(details?.supportedBy) && (
                  <div className="px-[20px] z-[1] relative">
                    <SupportedBy
                      sponsers={details?.supportedBy}
                      setSponsorPopup={setSponsorPopup}
                      setSponsorDetails={setSponsorDetails}
                    />
                    <div className="seperator" />
                  </div>
                )}
                {!_.isEmpty(details?.specialGuests) && (
                  <div className="px-[20px] relative z-[1]">
                    <SpecialGuests
                      data={details?.specialGuests}
                      setGuestPopup={setGuestPopup}
                      setGuestDetails={setGuestDetails}
                    />
                    <div className="seperator" />
                  </div>
                )}

                {!_.isEmpty(contestJudges) && (
                  <div className="px-[20px] relative z-[1]">
                    <div>
                      <Judges
                        judges={contestJudges}
                        isJudgE={isJudgE}
                        setJudgesPopup={setJudgesPopup}
                        setJudgeDetails={setJudgeDetails}
                      />
                      <div className="seperator" />
                    </div>
                  </div>
                )}
                {!_.isEmpty(details?.promoters) && (
                  <div className="px-[20px] z-[1] relative">
                    <Promoters
                      Promoters={details?.promoters}
                      setPromoterPopup={setPromoterPopup}
                      setPromoterDetails={setPromoterDetails}
                    />
                    <div className="seperator" />
                  </div>
                )}
                {!_.isEmpty(details?.sponsors) && (
                  <div className="px-[20px] z-[1] relative">
                    <Sponsers
                      sponsers={details?.sponsors}
                      setSponsorPopup={setSponsorPopup}
                      setSponsorDetails={setSponsorDetails}
                    />
                    <div className="seperator" />
                  </div>
                )}
                {!_.isEmpty(details?.organizer) && (
                  <div className="px-[20px] z-[1] relative">
                    <Organizer
                      organizer={details?.organizer}
                      setOrganizerPopup={setOrganizerPopup}
                      setOrganizerDetails={setOrganizerDetails}
                    />
                    <div className="seperator" />
                  </div>
                )}

                <div id="couponDiv">
                  {!_.isEmpty(coupons) && (
                    <div className=" md:max-w-[100%] relative z-10  ">
                      <Coupons
                        coupons={coupons}
                        setCoupons={setCoupons}
                        handleClickCounterCampaign={handleClickCounterCampaign}
                      />
                    </div>
                  )}
                  <div className=" md:max-w-[100%]  ">
                    {ads?.length != 0 && (
                      <Ads
                        ads={ads}
                        promotion={false}
                        setService={setService}
                        setServiceForm={setServiceForm}
                        setDetailsPopup={setDetailsPopup}
                        handleClickCounterCampaign={handleClickCounterCampaign}
                      />
                    )}
                  </div>
                </div>
                <div className="h-[100%] relative z-[1] p-[20px] cursor-pointer">
                  <div className="flex flex-col ">
                    <div className="flex flex-col gap-[12px] w-[100%]  font-medium  text-[#0F6ABE] text-regular">
                      {!hideRulesAndReg && (
                        <div onClick={() => setShowDetails(true)}>
                          <p>Rules and Regulations</p>
                        </div>
                      )}
                      {!hideTandC && (
                        <div onClick={() => setShowTerms(true)}>
                          <p>Terms & Conditions</p>
                        </div>
                      )}
                      {!hideFaq && (
                        <div
                          onClick={() => {
                            setShowFAQ(true);
                          }}
                        >
                          <p>FAQs </p>
                        </div>
                      )}
                    </div>
                    {!(hideRulesAndReg && hideTandC && hideFaq) && (
                      <div className="seperator mt-[20px]" />
                    )}
                  </div>
                </div>
                <div className="w-[100%] h-[70px] px-[20px] mt-[20px] z-[1] relative">
                  <div className="mt-[12px] flex items-center justify-between w-[100%]">
                    <div className="flex items-center ">
                      <p className="text-small text-[#606060]">
                        To launch a contest,
                      </p>
                      <span className="flex items-center justify-center">
                        <p
                          className="text-small text-[#0F6ABE] ml-[5px] cursor-pointer"
                          onClick={profileHelpNavigate}
                        >
                          contact us
                        </p>
                        <img
                          src={Bluearrow}
                          alt=""
                          className="w-[4px] h-[8px] ml-[5px]"
                        />
                      </span>
                    </div>
                    <img
                      src={buildType == "highonevent" ? hoeLogo : goviralLogo23}
                      alt=""
                      className="w-[90px]"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* {uploadSuccess && (
            <UploadSuccess
              uploadSuccessFile={uploadSuccessFile}
              singleFileDetails={contestDetails && contestDetails[0]}
              setUploadSucccess={setUploadSucccess}
              token={token}
            />
          )} */}
            {howToParticipatePopup && (
              <HowToParticipatePopup
                setHowToParticipatePopup={setHowToParticipatePopup}
                fileUrl={details?.howToParticipate?.fileUrl}
                heading="How To Participate"
              />
            )}
            {judgesPopup && (
              <JudgesPopup
                setJudgesPopup={setJudgesPopup}
                data={judgeDetails}
              />
            )}
            {promoterPopup && (
              <PromoterPopup
                setPromoterPopup={setPromoterPopup}
                data={promoterDetails}
              />
            )}
            {guestPopup && (
              <GuestPopup setGuestPopup={setGuestPopup} data={guestDetails} />
            )}
            {sponsorPopup && (
              <SponsorPopup
                setSponsorPopup={setSponsorPopup}
                data={sponsorDetails}
              />
            )}
            {organizerPopup && (
              <OrganizerPopup
                setOrganizerPopup={setOrganizerPopup}
                data={organizerDetails}
              />
            )}
            {showDetails && (
              <ContestTerms
                terms={rulesAndRegulations}
                setShowDetails={setShowDetails}
                heading="Rules And Regulations"
              />
            )}
            {showTerms && (
              <ContestTerms
                terms={details?.tandc}
                setShowDetails={setShowTerms}
                heading={"Terms and Conditions"}
              />
            )}
            {showFAQ && (
              <ContestTerms
                terms={faq}
                setShowDetails={setShowFAQ}
                heading={"FAQ"}
              />
            )}
            {serviceForm && (
              <ServiceForm service={service} setServiceForm={setServiceForm} />
            )}
          </div>
        )}
      </div>
    );
  }
}
export default ContestPage;
